module.exports = __webpack_public_path__ + "static/media/logo.f99f5685.png";